export default __webpack_public_path__ + "static/media/benefit_1@3x.222e4913.png";